import request from '@/utils/request';
import { BASE_API } from '@/utils/consts'
import { func } from 'prop-types';

// 升单配置查询
export function queryUpgradeOrderConfig(data) {
  return request(`${BASE_API}/upgrade_order/config/show`,{ data });
}

// 升单配置保存
export function saveUpgradeOrderConfig(data) {
  return request(`${BASE_API}/upgrade_order/config/update`, {
    method: 'POST',
    data
  });
}

// 查询所有升单规则分类
export function queryPromotionCategory(data) {
  return request(`${BASE_API}/upgrade_order/category/show`);
}

// 创建升单规则分类
export function addPromotionCategory(data) {
  return request(`${BASE_API}/upgrade_order/category/create`, {
    method: 'POST',
    data
  });
}

// 编辑升单规则分类
export function updatePromotionCategory(data) {
  return request(`${BASE_API}/upgrade_order/category/update`, {
    method: 'POST',
    data
  });
}

// 删除升单规则分类
export function deletePromotionCategory(data) {
  return request(`${BASE_API}/upgrade_order/category/delete/${data.categoryId}`, {
    method: 'DELETE'
  });
}

// 查询诊所下待添加到升单分类的所有产品
export function queryUpgradeOrderProductOption(data) {
  return request(`${BASE_API}/upgrade_order/product-option/list`, {
    method: 'POST',
    data
  });
}

// 给升单规则分类添加产品
export function addProductUpgradeOrder(data) {
  return request(`${BASE_API}/upgrade_order/product/add`, {
    method: 'POST',
    data
  });
}

// 删除升单规则分类下的产品
export function deleteProductUpgradeOrder(data) {
  return request(`${BASE_API}/upgrade_order/product/delete?categoryId=${data.categoryId}&productId=${data.productId}`, {
    method: 'DELETE'
  });
}

// 查询升单规则分类下的所有产品
export function queryAllUpgradeOrderProduct(data) {
  return request(`${BASE_API}/upgrade_order/product/list`, {
    method: 'POST',
    data
  });
}

// 查询升单列表
// export function queryOrderUpgradeList(data) {
//   return request(`${BASE_API}/upgrade_order/list`, {
//     method: 'POST',
//     data
//   });
// }

// 查询升单流水
export function queryOrderUpgradeList(data) {
  return request(`${BASE_API}/upgrade_order_log/list_by/order`, {
    method: 'POST',
    data
  });
}

// 查看升单详情
export function queryOrderUpgradeDetail(data) {
  return request(`${BASE_API}/upgrade_order/show/${data.id}`);
}

// 编辑升单金额
export function updateOrderUpgradeDetail(data) {
  return request(`${BASE_API}/upgrade_order/update`, {
    method: 'POST',
    data
  });
}

// 查询升单日志
export function updateOrderUpgradeLogList(data) {
  return request(`${BASE_API}/upgrade-order/log/list?upgradeOrderId=${data.upgradeOrderId}`, {
    method: 'POST'
  });
}

//诊所的规则一查询接口
export function getRule1Detail(data){
  return request(`${BASE_API}/upgrade_order_rule/clinic/rule1/show?clinicId=${data.clinicId}`, {
    method: 'GET'
  });
}
//诊所的规则四查询接口
export function getRule4Detail(data){
  return request(`${BASE_API}/upgrade_order_rule/clinic/rule4/show?clinicId=${data.clinicId}`, {
    method: 'GET'
  });
}

//诊所的规则二查询接口
export function getRule2Detail(data){
  return request(`${BASE_API}/upgrade_order_rule/clinic/rule2/show?clinicId=${data.clinicId}`, {
    method: 'GET'
  });
}

//诊所规则有效期 状态查询
export function getRule1Info(data){
  return request(`${BASE_API}/upgrade_order_rule/clinic_show?ruleType=${data.ruleType}&clinicId=${data.clinicId}`, {
    method: 'GET'
  });
}

//查询诊所升单商品列表
export function getProductList(data){
  return request(`${BASE_API}/upgrade_order/clinic/product/list`, {
    method: 'POST',
    data
  });
}

//查询诊所升单产品的产品分类列表
export function getCategoryList(data){
  return request(`${BASE_API}/upgrade_order/product_category/clinic/list`, {
    method: 'GET',
    data
  });
}

//查询诊所升单产品的升单分类列表
export function getUpOrderList(data){
  return request(`${BASE_API}/upgrade_order/upgrade_order_category/clinic/list`, {
    method: 'GET',
    data
  });
}
